import { FunctionComponent, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  configNameSelector,
  isLoggedInSelector,
} from '../redux/auth/selectors';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { fetchClientConfig } from '../redux/pages/actions';
import GeneralComponentErrorShield from '../components/general/GeneralComponentErrorShield';
import { clientConfigurationSelector } from '../redux/pages/selectors';
import { logOut } from '../redux/auth/actions';
import { useUserResources } from '../api/rs3-public/rsAuthAuthorization';
import TokenService from '../services/token-service';

const ProtectedRoutes: FunctionComponent = () => {
  const isAuthenticated = useSelector(isLoggedInSelector);
  const dispatch = useDispatch();
  const configName = useSelector(configNameSelector);
  const clientConfig = useSelector(clientConfigurationSelector);
  const cancelToken = axios.CancelToken;
  const source = cancelToken.source();
  const navigate = useNavigate();
  const location = useLocation();

  const userId = TokenService.getUser()?.user_id;
  useUserResources(userId, { enabled: !!isAuthenticated && !!userId });

  useEffect(() => {
    if (!configName || clientConfig.configId) return;
    dispatch(fetchClientConfig(configName, source));
  }, [configName, clientConfig.configId]);

  useEffect(() => {
    if (clientConfig.error) {
      dispatch(logOut());
    }
  }, [clientConfig]);

  const configError = `No client configuration for ${configName} was detected. Please contact the RiskSystem administrator.`;

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login', {
        state: { from: location },
      });
    }
  }, [isAuthenticated, navigate, location]);

  return (
    <GeneralComponentErrorShield
      dataObjects={clientConfig}
      customErrorMessage={configError}
      customLoadingMessages={['Loading your Raptor configuration...']}
    >
      <Outlet />
    </GeneralComponentErrorShield>
  );
};

export default ProtectedRoutes;
